import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../config/site";

const DEFAULT_IMAGE = `${SITE_URL}/jm.png`;

const PERSON_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "John Mendez",
  jobTitle: "Full-Stack Developer",
  description:
    "Full-stack developer specializing in React, TypeScript, Node.js, and AI-driven web applications.",
  url: SITE_URL,
  image: DEFAULT_IMAGE,
  knowsAbout: [
    "Full-stack development",
    "React",
    "TypeScript",
    "JavaScript",
    "Node.js",
    "REST APIs",
    "DevOps",
    "CI/CD",
    "Web performance optimization",
    "AI",
    "Machine learning",
    "Developer experience (DX)",
  ],
};

const Seo = ({ title, description, path = "/" }) => {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      {path === "/" && (
        <script type="application/ld+json">
          {JSON.stringify(PERSON_SCHEMA)}
        </script>
      )}
    </Helmet>
  );
};

export default Seo;
